// extracted by mini-css-extract-plugin
export default {"container":"FundNotice_container__l25iN","notice":"FundNotice_notice__f-U72","image":"FundNotice_image__tRew3","title":"FundNotice_title__RVB4p","text":"FundNotice_text__TJREg"};